export const moneyAud = (value) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(Number(value || 0));

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-AU", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(iso));
  } catch {
    return String(iso);
  }
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("en-AU", { dateStyle: "medium" }).format(new Date(iso));
  } catch {
    return String(iso);
  }
};

const COMMISSION_TONES = {
  ACCRUED: "info",
  APPROVED: "warning",
  PAID: "success",
  CANCELLED: "default",
};

export const commissionStatusTone = (status) => COMMISSION_TONES[status] || "default";

/** Cancelled rows are excluded from every total: they represent an amount that went away. */
export const commissionTotals = (rows) => {
  const totals = (rows || []).reduce(
    (acc, row) => {
      const amount = Number(row?.amount) || 0;
      if (row?.status === "ACCRUED") acc.accrued += amount;
      else if (row?.status === "APPROVED") acc.approved += amount;
      else if (row?.status === "PAID") acc.paid += amount;
      return acc;
    },
    { accrued: 0, approved: 0, paid: 0 }
  );
  return { ...totals, total: totals.accrued + totals.approved + totals.paid };
};
